"use client"

import { useEffect } from "react"

import { refresh } from "./actions"

export function DevAutoRefreshMarkdown({
  children,
}: {
  children: React.ReactNode
}) {
  return children
}

if (process.env.NODE_ENV === "development") {
  // @ts-expect-error mutation
  DevAutoRefreshMarkdown = function AutoRefresh({
    children,
  }: {
    children: React.ReactNode
  }) {
    useEffect(() => {
      const ws = new WebSocket("ws://localhost:3001")
      ws.onmessage = async (event) => {
        if (event.data === "refresh") {
          await refresh()
        }
      }
      return () => {
        ws.close()
      }
    }, [])

    return children
  }
}
